import { Button, Divider, Grid } from '@mui/material'
import React, { useState } from 'react'
import CommonAutoComplete from '../Common/CommonAutoComplete'
import { monthsOption, useCommonStyles } from '../../utils'
import CommonTextField from '../Common/CommonTextField'
import CommonLabel from '../Common/CommonLabel'
import CommonFileUpload from '../Common/CommonFileUpload'
import { useDispatch } from 'react-redux'
import usePageLoader from '../../Redux/hooks/usePageLoader'
import useSnackBar from '../../Redux/hooks/useSnackBar'
import { image } from '../../Redux/Actions/Vendor'
import ErrorHandler from '../../lib/errorHandler'
import CommonDatePicker from '../Common/CommonDatePicker'
import { addDocument, updateDocument } from '../../Redux/Actions/Documents'
import dayjs from 'dayjs'
import ErrorMessage from '../Common/ErrorMessage'
import { allowOnlyNumbers } from '../../utils/regex'
import { isCompleteDate } from '../../lib/standardDateFormat'

const AddUpdateDocument = ({ data, setData, activeTab, setSelectedItem, selectedItem, setIsOpenDrawer, yearOptions, _getDocuments }) => {
    // ============== Hooks ==============
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    // ============== State ==============
    const [errors, setErrors] = useState({});
    const [lightBillData, setLightBillData] = useState([
        {
            "id": 1,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        },
        {
            "id": 2,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        },
        {
            "id": 3,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        },
        {
            "id": 4,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        },
        {
            "id": 5,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        },
        {
            "id": 6,
            "document": "",
            "unit": '',
            "amount": '',
            "location_name": ""
        }
    ]);

    // =============== Handler  ===============
    const handleChange = (name, value) => {
        if (name == "startDate") {
            setData({ ...data, [name]: value, "endDate": null })
        } else {
            setData({ ...data, [name]: value })
        }
    }

    // console.log("data", data);

    const handleChnageLightbillItem = (id, name, value) => {
        const updatedItem = lightBillData?.map((ele) =>
            ele?.id == id ? { ...ele, [name]: value } : { ...ele })
        setLightBillData(updatedItem)
    }
    const handleDeleteLightbillImage = (id) => {
        const updatedItem = lightBillData?.map((ele) =>
            ele?.id == id ? { ...ele, document: "" } : { ...ele })
        setLightBillData(updatedItem)
    }

    const handleUploadImg = async (files, fieldName, lightbillId) => {
        setFullPageLoader(true);
        let response;
        const formData = new FormData();
        formData.append("image", files[0]);
        response = await dispatch(image(formData));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                const imageUrl = response?.payload?.data?.[0]?.image;
                if (lightbillId) {
                    const updatedItem = lightBillData?.map((ele) =>
                        ele?.id == lightbillId ? { ...ele, document: imageUrl } : { ...ele })
                    setLightBillData(updatedItem)
                } else {
                    if (imageUrl) {
                        setData((prev) => ({
                            ...prev,
                            [fieldName]: imageUrl,
                        }));
                    }
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };



    const validStep = () => {
        let formIsValid = true;
        let errors = {}
        if ([0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value)) {
            if (!data?.year?.id) {
                formIsValid = false;
                errors.year = "Please select year.";
            }
            if (!data?.month?.id) {
                formIsValid = false;
                errors.month = "Please select month.";
            }
        }
        if (activeTab?.value == 1) {
            if (!data?.documentName) {
                formIsValid = false;
                errors.documentName = "Please enter document name."
            }
            if (data?.expiryDate) {
                if (!isCompleteDate(data?.expiryDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid expiry date.")
                }
            }
        }
        if (activeTab?.value == 5) {
            if (!data?.receiptNumber) {
                formIsValid = false;
                errors.receiptNumber = "Please enter receipt number."
            }
        }
        if (activeTab?.value == 7) {
            if (data?.bankintrestAmount && data?.bankCharges) {
                if (+data?.bankintrestAmount <= +data?.bankCharges) {
                    formIsValid = false;
                    errors.invalidCharges = "Charges should not be greater than the total amount. Please correct the value."
                }
            }
        }
        if (activeTab?.value == 3) {
            if (!data?.policyNumber) {
                formIsValid = false;
                errors.policyNumber = "please enter policy number."
            }
            if (!data?.startDate) {
                formIsValid = false;
                errors.startDate = "please enter start date."
            }
            if (!data?.endDate) {
                formIsValid = false;
                errors.endDate = "please enter end date."
            }
            if (data?.startDate) {
                if (!isCompleteDate(data?.startDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid start date.")
                }
            }
            if (data?.endDate) {
                if (!isCompleteDate(data?.endDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid end date.")
                }
            }
            if (!data?.insuranceAmount) {
                formIsValid = false;
                errors.insuranceAmount = "please enter insurance amount."
            }
            if (!data?.assuredAmount) {
                formIsValid = false;
                errors.assuredAmount = "please enter assured amount."
            }
            if (!data?.companyName) {
                formIsValid = false;
                errors.companyName = "please enter company name."
            }
        }
        if (activeTab?.value == 12) {
            if (!data?.advanceLicenseNumber) {
                formIsValid = false;
                errors.advanceLicenseNumber = "please enter advance license number."
            }
            if (!data?.advanceLicenseDate) {
                formIsValid = false;
                errors.advanceLicenseDate = "please select advance license date."
            }
            if (data?.advanceLicenseDate) {
                if (!isCompleteDate(data?.advanceLicenseDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid advance license date.")
                }
            }
        }
        setErrors(errors);
        return formIsValid;
    };
    // ============= add Inventory Field API =============
    const _addUpdateInventoryField = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body;
            if (activeTab?.value == 0) {
                const finalLightbillData = lightBillData?.map((ele) => {
                    return {
                        "document": ele?.document ? ele?.document : null,
                        "unit": Number(ele?.unit),
                        "amount": Number(ele?.amount),
                        "location_name": ele?.location_name ? ele?.location_name : null
                    }
                })
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "light_bill": finalLightbillData
                }
            }
            if (activeTab?.value == 1) {
                body = {
                    "docsType": activeTab?.value,
                    "documentName": data?.documentName,
                    "expiryDate": data?.expiryDate ? dayjs(data?.expiryDate).format("YYYY-MM-DD") : null,
                    "document": data?.document,
                }
            }
            if (activeTab?.value == 2 || activeTab?.value == 4) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "document": data?.document,
                }
            }
            if (activeTab?.value == 3) {
                body = {
                    "docsType": activeTab?.value,
                    "policyNumber": data?.policyNumber,
                    "startDate": data?.startDate ? dayjs(data?.startDate).format("YYYY-MM-DD") : null,
                    "endDate": data?.endDate ? dayjs(data?.endDate).format("YYYY-MM-DD") : null,
                    "amount_1": data?.insuranceAmount,
                    "amount_2": data?.assuredAmount,
                    "location": data?.location,
                    "purpose": data?.purpose,
                    "companyName": data?.companyName,
                    "document": data?.document,
                }
            }
            if (activeTab?.value == 5) {
                body = {
                    "docsType": activeTab?.value,
                    "receiptNumber": data?.receiptNumber,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "amount_1": data?.pfAmount,
                    "challanDocument": data?.uploadChallanDocument,
                    "recieptDocument": data?.uploadReceiptDocument,
                    "form_1_Document": data?.uploadForm1Document
                }
            }
            if (activeTab?.value == 6) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "salary_1": +data?.s1,
                    "salary_2": +data?.s2,
                    "salary_3": +data?.s3,
                    "salary_4": +data?.s4,
                    "salary_5": +data?.s5,
                }
            }
            if (activeTab?.value == 7) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "amount_1": +data?.bankintrestAmount,
                    "bankCharge": +data?.bankCharges
                }
            }
            if (activeTab?.value == 8) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "amount_1": +data?.gasAmount,
                    "quantity": +data?.quantity
                }
            }
            if (activeTab?.value == 9) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "c1_kg": +data?.c1_kg,
                    "c2_kg": +data?.c2_kg,
                    "c3_kg": +data?.c3_kg,
                    "c4_kg": +data?.c4_kg,
                    "c5_kg": +data?.c5_kg,
                    "c6_kg": +data?.c6_kg,
                    "c1_sqmt": +data?.c1_sqmt,
                    "c2_sqmt": +data?.c2_sqmt,
                    "c3_sqmt": +data?.c3_sqmt,
                    "c4_sqmt": +data?.c4_sqmt,
                    "c5_sqmt": +data?.c5_sqmt,
                    "c6_sqmt": +data?.c6_sqmt,
                }
            }
            if (activeTab?.value == 10) {
                body = {
                    "docsType": activeTab?.value,
                    "year": +data?.year?.id,
                    "month": data?.month?.id,
                    "document": data?.document,
                }
            }
            if (activeTab?.value == 12) {
                body = {
                    "docsType": activeTab?.value,
                    "advanceLicenseNo": data?.advanceLicenseNumber,
                    "advanceLicenseDate": data?.advanceLicenseDate ? dayjs(data?.advanceLicenseDate).format("YYYY-MM-DD") : null,
                    "advanceLicenseQty": +data?.advanceLicenseQuantity,
                    "importQty": +data?.importQuantity,
                    "cifValue": +data?.cifValue,
                    "exportQty": +data?.exportQuantity,
                    "fobValue": +data?.fobValue,
                    "document": data?.document,
                    "importValue": +data?.importValue,
                    "exportValue": +data?.exportValue
                }
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updateDocument : addDocument
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setData({})
                    setSelectedItem({})
                    setIsOpenDrawer(false)
                    _getDocuments();
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    

    return (
        <Grid container spacing={2} p={3}>
            {(activeTab?.value == 5) &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            valid
                            type="number"
                            label="Receipt Number"
                            name="receiptNumber"
                            value={data?.receiptNumber}
                            placeholder="Enter The Receipt Number"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("receiptNumber", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <ErrorMessage text={(activeTab?.value == 5 && !data?.receiptNumber) ? errors.receiptNumber : ""} />
                    </Grid>
                </>
            }
            {(activeTab?.value == 0 || activeTab?.value == 2 || activeTab?.value == 4 || activeTab?.value == 5 || activeTab?.value == 6 || activeTab?.value == 7 || activeTab?.value == 8 || activeTab?.value == 9 || activeTab?.value == 10) &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            valid
                            label={"Year"}
                            placeholder={"Select Year"}
                            options={yearOptions}
                            value={data?.year}
                            onChange={(event, newValue) => handleChange("year", newValue)}
                        />
                        <ErrorMessage text={[0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) && !data?.year?.id ? errors.year : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label={"Month"}
                            placeholder={"Select Month"}
                            options={monthsOption}
                            valid
                            value={data?.month}
                            onChange={(event, newValue) => handleChange("month", newValue)}
                        />
                        <ErrorMessage text={[0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) && !data?.month?.id ? errors.month : ""} />
                    </Grid>
                </>
            }
            {activeTab?.value == 0 &&
                lightBillData?.map((ele, index) => {
                    return (
                        <>
                            <Grid item xs={12} >
                                <Divider />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CommonTextField
                                    type="text"
                                    label={`Location ${ele?.id}`}
                                    name="location_name"
                                    value={ele?.location_name}
                                    placeholder="Enter The Location"
                                    onChange={(e) => handleChnageLightbillItem(ele?.id, "location_name", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CommonTextField
                                    type="number"
                                    label="Unit"
                                    name="unit"
                                    value={ele?.unit}
                                    placeholder="Enter The Unit"
                                    onChange={(e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChnageLightbillItem(ele?.id, "unit", e.target.value)
                                        } else {
                                            return;
                                        }
                                    }}
                                    onKeyDown={allowOnlyNumbers}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CommonTextField
                                    type="number"
                                    label="Amount"
                                    name="amount"
                                    value={ele?.amount}
                                    placeholder="Enter The Amount"
                                    onChange={(e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChnageLightbillItem(ele?.id, "amount", e.target.value)
                                        } else {
                                            return;
                                        }
                                    }}
                                    onKeyDown={allowOnlyNumbers}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <CommonLabel title={'Upload Document'} />
                                <CommonFileUpload
                                    id={ele?.id}
                                    value={ele?.document}
                                    handleImageChange={(files) => handleUploadImg(files, "document", ele?.id)}
                                    accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                    handleSingleDelete={() => handleDeleteLightbillImage(ele?.id)}
                                />
                            </Grid>

                        </>
                    )
                })
            }
            {activeTab?.value == 1 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            valid
                            type="text"
                            label="Document Name"
                            name="documentName"
                            value={data?.documentName}
                            placeholder="Enter Document Name"
                            onChange={(e) => handleChange("documentName", e.target.value)}
                        />
                        <ErrorMessage text={!data?.documentName ? errors.documentName : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonDatePicker
                            label="Expiry Date"
                            onChange={(value) => handleChange("expiryDate", value)}
                            value={data?.expiryDate || null}
                            name="expiryDate"
                            minDate={new Date()}
                        />
                    </Grid>
                </>
            }
            {activeTab?.value == 3 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            valid
                            label="Policy Number"
                            name="policyNumber"
                            value={data?.policyNumber}
                            placeholder="Enter Policy Number"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("policyNumber", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.policyNumber) ? errors.policyNumber : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonDatePicker
                            valid
                            label="Start Date"
                            onChange={(value) => handleChange("startDate", value)}
                            value={data?.startDate || null}
                            name="startDate"
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.startDate) ? errors.startDate : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonDatePicker
                            valid
                            label="End Date"
                            onChange={(value) => handleChange("endDate", value)}
                            value={data?.endDate || null}
                            name="endDate"
                            disabled={!data?.startDate}
                            minDate={data?.startDate}
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.endDate) ? errors.endDate : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            valid
                            label="Amount"
                            name="insuranceAmount"
                            value={data?.insuranceAmount}
                            placeholder="Enter Amount"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("insuranceAmount", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.insuranceAmount) ? errors.insuranceAmount : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            valid
                            label="Assured Amount"
                            name="assuredAmount"
                            value={data?.assuredAmount}
                            placeholder="Enter Assured Amount"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("assuredAmount", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.assuredAmount) ? errors.assuredAmount : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="text"
                            label="Purpose"
                            name="purpose"
                            value={data?.purpose}
                            placeholder="Enter Purpose"
                            onChange={(e) => handleChange("purpose", e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="text"
                            label="Company Name"
                            name="companyName"
                            valid
                            value={data?.companyName}
                            placeholder="Enter Company Name"
                            onChange={(e) => handleChange("companyName", e.target.value)}
                        />
                        <ErrorMessage text={(activeTab?.value == 3 && !data?.companyName) ? errors.companyName : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="text"
                            label="Location"
                            name="location"
                            value={data?.location}
                            placeholder="Enter Location"
                            onChange={(e) => handleChange("location", e.target.value)}
                        />
                    </Grid>
                </>
            }
            {activeTab?.value == 5 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="Amount"
                            name="pfAmount"
                            value={data?.pfAmount}
                            placeholder="Enter The Amount"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("pfAmount", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <CommonLabel title={'Upload Challan Document'} />
                        <CommonFileUpload
                            id="uploadChallanDocument"
                            value={data?.uploadChallanDocument}
                            handleImageChange={(files) => handleUploadImg(files, "uploadChallanDocument")}
                            accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                            handleSingleDelete={() => {
                                setData({
                                    ...data,
                                    uploadChallanDocument: "",
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <CommonLabel title={'Upload Receipt Document'} />
                        <CommonFileUpload
                            id="uploadReceiptDocument"
                            value={data?.uploadReceiptDocument}
                            handleImageChange={(files) => handleUploadImg(files, "uploadReceiptDocument")}
                            accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                            handleSingleDelete={() => {
                                setData({
                                    ...data,
                                    uploadReceiptDocument: "",
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <CommonLabel title={'Upload Form 1 Document'} />
                        <CommonFileUpload
                            id='uploadForm1Document'
                            value={data?.uploadForm1Document}
                            handleImageChange={(files) => handleUploadImg(files, "uploadForm1Document")}
                            accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                            handleSingleDelete={() => {
                                setData({
                                    ...data,
                                    uploadForm1Document: "",
                                });
                            }}
                        />
                    </Grid>
                </>
            }

            {activeTab?.value == 6 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="S1"
                            name="s1"
                            value={data?.s1}
                            placeholder="Enter S1"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("s1", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="S2"
                            name="s2"
                            value={data?.s2}
                            placeholder="Enter S2"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("s2", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="S3"
                            name="s3"
                            value={data?.s3}
                            placeholder="Enter S3"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("s3", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="S4"
                            name="s4"
                            value={data?.s4}
                            placeholder="Enter S4"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("s4", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="S5"
                            name="s5"
                            value={data?.s5}
                            placeholder="Enter S5"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("s5", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                </>
            }
            {activeTab?.value == 7 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="Amount"
                            name="bankintrestAmount"
                            value={data?.bankintrestAmount}
                            placeholder="Enter Amount"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("bankintrestAmount", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="Bank Charges"
                            name="bankCharges"
                            value={data?.bankCharges}
                            placeholder="Enter Bank Charges"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("bankCharges", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                        <ErrorMessage text={(activeTab?.value === 7 && data?.bankintrestAmount && data?.bankCharges) && +data?.bankintrestAmount <= +data?.bankCharges ? errors.invalidCharges : ""} />
                    </Grid>
                </>
            }
            {activeTab?.value == 8 &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="Amount"
                            name="gasAmount"
                            value={data?.gasAmount}
                            placeholder="Enter Amount"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("gasAmount", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            type="number"
                            label="Quantity"
                            name="quantity"
                            value={data?.quantity}
                            placeholder="Enter Quantity"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("quantity", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                </>
            }
            {activeTab?.value == 9 &&
                <>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C1 (Kg)"
                            name="c1_kg"
                            value={data?.c1_kg}
                            placeholder="Enter C1 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c1_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C2 (Kg)"
                            name="c2_kg"
                            value={data?.c2_kg}
                            placeholder="Enter C2 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c2_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C3 (Kg)"
                            name="c3_kg"
                            value={data?.c3_kg}
                            placeholder="Enter C3 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c3_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C4 (Kg)"
                            name="c4_kg"
                            value={data?.c4_kg}
                            placeholder="Enter C4 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c4_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C5 (Kg)"
                            name="c5_kg"
                            value={data?.c5_kg}
                            placeholder="Enter C5 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c5_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C6 (Kg)"
                            name="c6_kg"
                            value={data?.c6_kg}
                            placeholder="Enter C6 (Kg)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c6_kg", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C1 (Sqmt)"
                            name="c1_sqmt"
                            value={data?.c1_sqmt}
                            placeholder="Enter C1 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c1_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C2 (Sqmt)"
                            name="c2_sqmt"
                            value={data?.c2_sqmt}
                            placeholder="Enter C2 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c2_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C3 (Sqmt)"
                            name="c3_sqmt"
                            value={data?.c3_sqmt}
                            placeholder="Enter C3 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c3_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C4 (Sqmt)"
                            name="c4_sqmt"
                            value={data?.c4_sqmt}
                            placeholder="Enter C4 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c4_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C5 (Sqmt)"
                            name="c5_sqmt"
                            value={data?.c5_sqmt}
                            placeholder="Enter C5 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c5_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CommonTextField
                            type="number"
                            label="C6 (Sqmt)"
                            name="c6_sqmt"
                            value={data?.c6_sqmt}
                            placeholder="Enter C6 (Sqmt)"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("c6_sqmt", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                </>
            }
            {activeTab?.value == 12 &&
                <>
                    <Grid item xs={12} sm={6} >
                        <CommonTextField
                            valid
                            type="text"
                            label="Advance License Number"
                            name="advanceLicenseNumber"
                            value={data?.advanceLicenseNumber}
                            placeholder="Enter Advance License Number"
                            onChange={(e) => handleChange("advanceLicenseNumber", e.target.value)}
                        />
                        <ErrorMessage text={(activeTab?.value === 12 && !data?.advanceLicenseNumber) ? errors.advanceLicenseNumber : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonDatePicker
                            valid
                            label="Advance License Date"
                            onChange={(value) => handleChange("advanceLicenseDate", value)}
                            value={data?.advanceLicenseDate || null}
                            name="advanceLicenseDate"
                        />
                        <ErrorMessage text={(activeTab?.value === 12 && !data?.advanceLicenseDate) ? errors.advanceLicenseDate : ""} />
                    </Grid>
                    {/* <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="Advance License Quantity"
                            name="advanceLicenseQuantity"
                            value={data?.advanceLicenseQuantity}
                            placeholder="Enter Advance License Quantity"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("advanceLicenseQuantity", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid> */}
                    <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="Export Quantity"
                            name="exportQuantity"
                            value={data?.exportQuantity}
                            placeholder="Enter Export Quantity"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("exportQuantity", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="Import Quantity"
                            name="importQuantity"
                            value={data?.importQuantity}
                            placeholder="Enter Import Quantity"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("importQuantity", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                     <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="Export value"
                            name="exportValue"
                            value={data?.exportValue}
                            placeholder="Enter Export value"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("exportValue", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                     <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="Import value"
                            name="importValue"
                            value={data?.importValue}
                            placeholder="Enter Import value"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("importValue", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="FOB Value"
                            name="fobValue"
                            value={data?.fobValue}
                            placeholder="Enter FOB Value"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("fobValue", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} >
                        <CommonTextField
                            type="number"
                            label="CIF Value"
                            name="cifValue"
                            disabled
                            value={data?.cifValue || 0}
                            placeholder="Enter CIF Value"
                            onChange={(e) => {
                                if (+e?.target?.value >= 0) {
                                    handleChange("cifValue", e.target.value)
                                } else {
                                    return;
                                }
                            }}
                            onKeyDown={allowOnlyNumbers}
                        />
                    </Grid> */}
                </>
            }
            {![0, 5, 6, 7, 8, 9].includes(activeTab?.value) &&
                <Grid item xs={12} >
                    <CommonLabel title={'Upload Document'} />
                    <CommonFileUpload
                        id='document'
                        value={data?.document}
                        handleImageChange={(files) => handleUploadImg(files, "document")}
                        accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                        handleSingleDelete={() => {
                            setData({
                                ...data,
                                document: "",
                            });
                        }}
                    />
                </Grid>
            }
            <Grid item xs={12} display={"flex"} gap={2} mt={1}>
                <Button className={classes.saveButton} onClick={() => _addUpdateInventoryField()}>{selectedItem?._id ? "Update" : "Create"}</Button>
                <Button className={classes.cancelButton} onClick={() => { setData({}); setIsOpenDrawer(false); setSelectedItem({}); }}>Cancel</Button>
            </Grid>
        </Grid>
    )
}

export default AddUpdateDocument